// 261010 U9 — MỘT luật duy nhất «có hộp xác nhận không» cho bảng Film (THUẦN, 0 antd).
// Quyết định User/Leader: hộp xác nhận CHỈ trước khi tạo clip video (bước VIDEO — chạy / «Gen tất cả» / tạo lại clip; hộp giữ ước giá tổng, quyết định #34). Mọi lần chạy / chạy lại bước khác chạy NGAY khi bấm.
// Thao tác phá huỷ (xoá, bỏ nháp, khôi phục, thay thế, làm clip cũ đi, gộp/cắt cấu trúc) giữ hộp — chúng không phải «chạy». Cờ `confirm:true` gửi BE vẫn tự gửi: cú bấm của người là xác nhận.
import type { WorkflowStepKey } from '../../types/filmWorkflow';

export type ConfirmAction =
  | 'RUN' | 'RERUN' | 'RUN_FAILED' | 'GEN_CLIP' | 'APPROVE'
  | 'UPLOAD' | 'INSERT'
  | 'DELETE' | 'DISCARD' | 'RESTORE' | 'REVOKE' | 'REPLACE' | 'INVALIDATE' | 'STRUCT_CHANGE';

/** Các hành động «chạy» — chỉ hỏi khi tạo clip video. */
export const RUN_ACTIONS: ConfirmAction[] = ['RUN', 'RERUN', 'RUN_FAILED', 'GEN_CLIP'];
/** Không phá huỷ, không tốn: không bao giờ hỏi. */
export const FREE_ACTIONS: ConfirmAction[] = ['UPLOAD', 'INSERT'];
/** Phá huỷ / thay thế / làm cũ: luôn hỏi, mọi bước. */
export const DESTRUCTIVE_ACTIONS: ConfirmAction[] = ['DELETE', 'DISCARD', 'RESTORE', 'REVOKE', 'REPLACE', 'INVALIDATE', 'STRUCT_CHANGE'];

/**
 * `step` = bước của hành động; `nextStep` = bước mà việc duyệt sẽ chạy tiếp (chỉ với APPROVE).
 * - Chạy: hỏi ⇔ bước là VIDEO.
 * - Duyệt: không phải «chạy» ⇒ hỏi ⇔ duyệt này kéo theo chạy VIDEO.
 * - Phá huỷ: luôn hỏi. Miễn phí/không phá huỷ: không hỏi.
 */
export function needsConfirm(step: WorkflowStepKey | null | undefined, action: ConfirmAction, nextStep?: WorkflowStepKey | null): boolean {
  if (DESTRUCTIVE_ACTIONS.includes(action)) return true;
  if (FREE_ACTIONS.includes(action)) return false;
  if (action === 'APPROVE') return nextStep === 'VIDEO';
  return step === 'VIDEO';
}

/**
 * Hành động xác nhận của «chạy chặng 1 Phân đoạn». Chạy lần đầu = 'RUN' (không hộp). CHẠY LẠI khi đã có kết quả = 'REPLACE' (phá huỷ: ghi đè mọi video + sửa tay, có thể mất duyệt) ⇒ LUÔN giữ hộp xác nhận.
 */
export function stage1ConfirmActionOf(rerun: boolean | undefined): ConfirmAction {
  return rerun ? 'REPLACE' : 'RUN';
}
